import { ChangeLogActionType, ChangeLogEntityType, ChangeLogType } from '../../types';

export class ChangeLogEntity {
  id: number;
  description?: string;
  loggedById: number;
  loggedBy?: string;
  logDate: Date;
  entity?: object;
  entityName_En: string;
  entityName_Fr: string;
  entityType?: ChangeLogEntityType;
  changeLogActionType?: ChangeLogActionType;
  changeLogType?: ChangeLogType;
  changeReason_En: string;
  changeReason_Fr: string;
  number: number;

  constructor(entity?: ChangeLogEntity) {
    if (entity) {
      Object.assign(this, { ...entity });
    }
  }
}
